import React from 'react';

import ThemeRebranding from './ThemeRebranding';

const ThemeSelector: React.FC = ({ children }) => {
  return (
    <>
      <ThemeRebranding />
      {children}
    </>
  );
};

export default ThemeSelector;
